import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CommonResponse } from 'models';
import { Overlay } from './models/overlay';

export interface OverlayState {
  loading: boolean;
  data: Overlay[];
}

const initialState: OverlayState = {
  loading: false,
  data: [],
};

const overlaySlice = createSlice({
  name: 'overlay',
  initialState,
  reducers: {
    fetchOverlayList(state) {
      state.loading = true;
    },
    fetchOverlayListSuccess(state, action: PayloadAction<CommonResponse<Overlay[]>>) {
      state.data = action.payload.data;
      state.loading = false;
    },
    fetchOverlayListFailed(state) {
      state.loading = false;
    },
    clearOverlayList(state) {
      state.data = [];
      state.loading = false;
    },
  },
});

// Actions
export const overlayActions = overlaySlice.actions;

// Selectors
export const selectStoreOverlayListData = (state: RootState) => state.overlay.data;
export const selectStoreOverlayListIsLoading = (state: RootState) => state.overlay.loading;

// Reducer
export const overlayReducer = overlaySlice.reducer;
